/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ platform: NonNullable<unknown> }} Directory_Platforms_Listing_TitleInputs */

const en_directory_platforms_listing_title = /** @type {(inputs: Directory_Platforms_Listing_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.platform} products`)
};

const zh_directory_platforms_listing_title = /** @type {(inputs: Directory_Platforms_Listing_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.platform} 产品`)
};

/**
* | output |
* | --- |
* | "{platform} products" |
*
* @param {Directory_Platforms_Listing_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_platforms_listing_title = /** @type {((inputs: Directory_Platforms_Listing_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Platforms_Listing_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_platforms_listing_title(inputs)
	return zh_directory_platforms_listing_title(inputs)
});
export { directory_platforms_listing_title as "directory.platforms.listing_title" }